<template>
  <div id="contract">

    <!-- 左侧区域 -->
    <div class="left">
      <div class="top">
        <div class="title">任务信息 | {{ contractId }}</div>
      </div>
      <card-m
        title="任务详情信息"
        cardWidth="100%"
        cardHeight="90%"
        minHeight="90%"
        :minWidth="0"  

        >
        <template slot="card-box">
          <card-info-table1
            :data="taskDetailItems" 
            :label-width="'30%'"   
            :row-height="'40px'"
            :font-size="'13px'"
            :label-bg-color="'rgba(37, 100, 207, 0.08)'"
            :border-color="'#dcdfe6'"
            :hover-effect="false"
            :empty-text="'—'"
          />
        </template>
      </card-m>

    </div>

    <!-- 右侧区域 -->
    <div class="right">
      <!-- 预留顶部空间 -->
      <div class="top">
      </div>
      <!-- cardHeight="42%"：卡片高度为父容器高度的42%, -->
      <!--  minHeight="42%"：设置最小高度为42%，防止内容过少时卡片收缩-->
      <!-- 动态显示产品数量 -->
      <card-m 
        :title="'产品列表 (' + ProductData.length + ')'"
        cardWidth="96%"
        cardHeight="48%"  
        minHeight="48%"
       >
        <!-- 定义卡片主体内容的插槽,slot="card-box"指定内容插入到card-m组件的card-box插槽位置 -->
        <template slot="card-box">
          <!-- 产品列表表格组件 -->    
          <!-- showPaging="false"：禁用分页功能，表格显示所有数据 -->    
          <!-- total="tableProductDataTotal"：绑定总数据条数（虽然分页禁用，但可能用于统计显示） -->    
          <!-- @sizeChange="handleSizeChange"：分页大小改变时触发handleSizeChange方法 -->    
          <!-- @currentChange="handleCurrentChange"：当前页码改变时触发handleCurrentChange方法 -->    
          <!-- tableColumn="productListColumn"：绑定表格列配置数据 -->    
          <!-- tableData="ProductData"：绑定产品列表数据 -->    
          <!-- @rowClick="goToInfo"：行点击事件，触发goToInfo方法跳转到详情页面 -->    
          <cardTable
            :showPaging="false"
            :total="tableProductDataTotal"
            @sizeChange="handleSizeChange"
            @currentChange="handleCurrentChange"
            :tableColumn="productListColumn"
            :tableData="ProductData"
            @rowClick="goToInfo"
          >
          </cardTable>
        </template>
      </card-m>
      
      <!-- 两个卡片各占42%高度，总共84%，剩余16%用于.top区域和间距 -->
      <card-m 
        title="物料情况" 
        cardWidth="96%"
        cardHeight="48%"
        minHeight="48%"
        >
        <template slot="card-box">
          <cardTable
            :showPaging="false"
            :tableColumn="taskListColumn"
            :tableData="TaskData"
            @rowClick="goToTaskInfo"
          >
          </cardTable>
        </template>
      </card-m>
    </div>

    <!-- 弹窗区域 -->
    <!-- 
    :visible="taskDialogVisible"：双向绑定弹窗显示状态，true显示/false隐藏
    :before-close="closeTaskDialog"：弹窗关闭前的回调函数，执行关闭逻辑
    title="物料详情"：设置弹窗默认标题（但会被slot覆盖）
    width="80%"：弹窗宽度为视口宽度的80%
    :center="false"：禁用内容居中，保持左对齐布局 -->

<!-- TODO:FAN问题记录弹窗 -->
<el-dialog
  :visible="issueDialogVisible"
  :before-close="closeIssueDialog"
  title="产品问题记录"
  width="70%"
  :center="false"
>
  <div slot="title" class="materialDetailTitle">
    <div class="materialDetailTitle_title">
      产品问题记录 - 产品ID: {{ currentProductId }}
    </div>
  </div>
  <div class="taskDialog">
    <cardTable
      :showPaging="false"
      :tableColumn="issueListColumn"
      :tableData="issueList"
    >
    </cardTable>
  </div>
</el-dialog>
  

  </div>
</template>

<script>
import {
  getProductInfoList,
} from '@/api/mainapi.js';
import { convertDateFormat } from '@/utils/tools.js';
export default {
  name: 'classification',
  data() {
    return {

       // TODO:FAN任务进度弹窗相关数据
      taskProgressDialogVisible: false,
      taskProgressLoading: false,
      taskProgressData: [],
      taskProgressTotal: 0,
      taskProgressPage: 1,
      taskProgressPageSize: 5,
      pendingBindingQuantity: 0, // 待绑定产品数量




      ProductData: [], //产品列表
      TaskData: [], //任务列表

      
      //TODO:FAN新增问题记录弹窗相关数据
      issueDialogVisible: false,
      issueList: [],
      issueListColumn: [
        {
          prop: 'create_time',
          label: '创建时间'
        },
        {
          prop: 'field0002',
          label: '问题描述'
        },
        {
          prop: 'SHOWVALUE',
          label: '问题类型'
        }
      ],
      currentProductId: '', // 当前点击的产品ID

  
      productListColumn: [
        {
          prop: 'index',  // 新增序号列
          label: '序号',
          width: 20,
        },
        {
          prop: 'serial_code',
          label: '产品编号'
        },
        {
          prop: 'name',
          label: '产品名称'
        },
        {
          prop: 'model',
          label: '产品型号'
        },  
        {
          prop: 'execute_name',
          label: '产品状态'
        },
        {
          prop: 'issueDisplay',
          label: '有无问题',
          width: 100

        },
      ],
      taskListColumn: [
        {
          prop: '代码',
          label: '短代码'
        },
        {
          prop: '名称',
          label: '名称'
        },
        {
          prop: '规格型号',
          label: '型号'
        },
        {
          prop: '投料数',
          label: '投料数'
        },
        {
          prop: '已领',
          label: '已领数'
        },
        {
          prop: '现场缺料',
          label: '缺料数'
        },
        {
          prop: '库存',
          label: '库存数'
        },
        {
          prop: '在途',
          label: '在途数'
        },
        {
          prop: '标准用量',
          label: '标准用量'
        },
        {
          prop: '单位',
          label: '单位'
        },
        {
          prop: '领料标志',
          label: '领料状态'
        }
      ],

      contractInfo: {
        fheadselfs0155: '',
        fheadselfs0159: '',
        fheadselfs0160: '',
        fheadselfs0161: '',
        FCust: '',
        FDept: '',
        FEmp: '',
        finterid: ''
      }, //合同详情

    };
  },
  computed: {
    contractId() {
      if (window.location.href.indexOf('id') > 0) {
        let url = window.location.href;
        let id = decodeURIComponent(url).split('?id=')[1];
        return id;
      } else if (window.sessionStorage.getItem('currentContractId')) {
        return window.sessionStorage.getItem('currentContractId');
      }
    },

      taskDetailItems() {
    return [
      { label: '任务状态', value: this.contractInfo.fstatus },
      { label: '产品名称', value: this.contractInfo.FName },
      { label: '短代码', value: this.contractInfo.FShortNumber },
      { label: '型号', value: this.contractInfo.FModel },
      { label: '装配人员', value: this.assemblyPersonnel }, // 确保此数据在data中定义和赋值
      { label: '开工时间', value: this.startTime || 0 },
      { label: '交货时间', value: this.contractInfo.FPlanFinishDate },
      { label: '总产品数量', value: this.contractInfo.FQty || 0 },
      { label: '待绑定产品数量', value: this.pendingBindingQuantity },
      { label: '量程', value: this.measuringRange || 0 },
      { label: '备注', value: this.contractInfo.FNote || '暂无备注' }
    ];
  }


  },
  mounted() {
    let url = window.location.href;
    let contractId;
    if (window.location.href.indexOf('id') > 0) {
      let url = window.location.href;
      contractId = decodeURIComponent(url).split('?id=')[1];
      // window.sessionStorage.setItem('currentContractId', contractId);
    } else if (window.sessionStorage.getItem('currentContractId')) {
      contractId = window.sessionStorage.getItem('currentContractId');
    }
    this.getDetilById(contractId);
  },
  methods: {
    // 根据id查询合同详情
    async getDetilById(id) {
      const params = {
        Type: 'TaskNumInformation',
        msg: id
      };
      const res = await getProductInfoList(params);

      if (res.data.code === 200) {
        // 直接使用接口返回的数据结构
        this.contractInfo = res.data.data.icmoInfo || {}; // 使用icmoInfo作为合同信息
        this.ProductData = res.data.data.products || [];   // 使用products作为产品列表
        this.TaskData = res.data.data.bom || [];          // 使用bom作为任务列表
        
        // 日期格式化处理
        if (this.contractInfo.FPlanFinishDate) {
          this.contractInfo.FPlanFinishDate = convertDateFormat(this.contractInfo.FPlanFinishDate);
        }

        // 新增：计算待绑定产品数量
        // this.calculatePendingBindingQuantity();   
        
        // 为每个产品添加序号和问题显示文本
        this.ProductData.forEach((product, index) => {
          product.index = index + 1;
          // 添加问题显示文本
          product.issueDisplay = product.isIssue ? '有' : ' ';
        })
     
      } else {
        this.$message.error('获取合同详情失败');
      }
    },

    // 计算待绑定产品数量
    calculatePendingBindingQuantity() {
      // 总产品数量（从合同信息获取）
      const totalQuantity = parseInt(this.contractInfo.FQty) || 0;
      
      // 已绑定产品数量（产品列表中的产品总数）
      const boundQuantity = this.ProductData.length;
      
      // 待绑定产品数量 = 总产品数量 - 已绑定产品数量
      this.pendingBindingQuantity = Math.max(0, totalQuantity - boundQuantity);
    },

      // 序号列索引方法
    indexMethod(index) {
      return index + 1;  // 从1开始编号
    },


    // TODO:FAN产品列表行点击事件 - 查询问题记录
    async goToInfo(data) {
      
      // 保存当前点击的产品ID
      this.currentProductId = data.id;
      
      try {
        // 调用后端接口查询问题记录
        const params = {
          Type: 'ProductIssue',
          msg: data.id.toString() // 确保是字符串类型
        };
        
        const res = await getProductInfoList(params);
        
        if (res.data.code === 200) {
          if (res.data.data.issue === '空' || !res.data.data.issue || res.data.data.issue.length === 0) {
            // 问题记录为空
            this.$message.info('该产品没有问题记录');
          } else {
            // 有问题记录，显示弹窗
            this.issueList = res.data.data.issue;
            this.issueDialogVisible = true;
          }
        } else {
          this.$message.error('查询问题记录失败: ' + res.data.message);
        }
      } catch (error) {
        this.$message.error('查询问题记录失败');
      }
    },

    // TODO:FAN关闭问题记录弹窗
    closeIssueDialog() {
      this.issueDialogVisible = false;
      this.issueList = [];
      this.currentProductId = '';
    }
    // //从ERP获取BOM数据
    // async getERPBOM(FBOMNumber) {
    //   const params = {
    //     Type: 'ERPBOM',
    //     msg: FBOMNumber,
    //     Page: this.currentERPBOMPage,
    //     PageSize: this.ERPBOMPageSize
    //   };
    //   this.ERPBOMloading = true;
    //   const res = await apiMainMultiple(params);
    //   this.ERPBOMloading = false;
    //   this.ERPBOMTotal = Number(res.data.data.total);
    //   this.ERPBOMList = res.data.data.list;
    // },
    // handleERPBOMPageSizeChanges(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.ERPBOMPageSize = val;
    //   this.getERPBOM(this.FBOMNumber);
    // },
    // handlecurrentERPBOMChanges(val) {
    //   console.log(`当前页: ${val}`);
    //   this.currentERPBOMPage = val;
    //   this.getERPBOM(this.FBOMNumber);
    // },
    // // 从任务列表跳转缺料详情弹框
    // goToTaskInfo(data) {
    //   this.taskDialogVisible = true;
    //   this.gettaskMaterialList(data.fbillno);
    // },
    // //关闭任务列表详情弹框
    // closeTaskDialog() {
    //   this.taskDialogVisible = false;
    // },
    // //关闭任务列表详情弹框
    // closeDetailDialog() {
    //   this.detailDialogVisible = false;
    // },
    // // 获取任务缺料详情列表
    // async gettaskMaterialList(id) {
    //   this.taskMaterialListCopy = [];
    //   const params = {
    //     msg: id,
    //     Type: 'ICMO'
    //   };
    //   const res = await apiMain(params);
    //   this.taskMaterialList = res.data.data;
    //   res.data.data.forEach((item) => {
    //     this.taskMaterialListCopy.push(item);
    //   });
    // },
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);

    //   this.getProductDataById(this.contractInfo.finterid);
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`);
    //   this.getProductDataById(this.contractInfo.finterid);
    // },
    // changeRange(data) {
    //   this.currentDateRange = data;
    // }
  }
};
</script>

<style scoped lang="scss">
#contract {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 900px; // 增加最小宽度
  gap: 20px; // 使用gap替代padding
  padding: 0 20px;
  box-sizing: border-box;
  overflow: auto; // 防止内容溢出



  .left {
    flex: 0 0 350px; // flex-grow: 0, flex-shrink: 0, flex-basis: 350px
    min-width: 300px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
  }

  .right {
    flex: 1 1 600px; // 可伸缩，基础宽度600px
    min-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

// 响应式调整
// @media (max-width: 1200px) {
//   #contract {
//     min-width: 800px;
//     gap: 15px;
    
//     .left {
//       flex-basis: 320px;
//       min-width: 280px;
//     }
    
//     .right {
//       min-width: 450px;
//     }
//   }
// }

@media (max-width: 900px) {
  #contract {
    flex-direction: column;
    min-width: 600px;

    
    .left, .right {
      flex: none;
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
  }
}

// 添加问题单元格样式
.has-issue-cell {
  background-color: #ffebee !important; /* 浅红色背景 */
  color: #d32f2f !important; /* 深红色文字 */
  font-weight: bold;
}

// 如果需要整行高亮，可以添加行样式
.has-issue-row {
  background-color: #ffebee !important;
}

.top {
  height: 60px;
  margin-bottom: 0; // 移除margin，用gap替代
  
  .title {
    position: relative;
    width: 100%; // 宽度自适应
    max-width: 400px; // 最大宽度限制
    height: 97%;
    font-size: clamp(1.1rem, 2vw, 1.3rem); // 响应式字体大小
    color: rgba(37, 100, 207, 0.8);
    border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
    display: flex;
    align-items: center;
  }
}

// 改进卡片信息布局 - 两列网格布局
.card-info {
  display: grid;
  gap: 12px 20px; // 行间距12px，列间距20px
  align-items: start;
    min-width: 300px;
  
  .card_info_lable {
    color: #616161;
    font-family: 'Microsoft YaHei';
    font-size: clamp(14px, 1.5vw, 16px); // 响应式字体
    font-weight: 600;
    line-height: 1.4;
    text-align: left;
    margin-top: 0; // 移除margin，用grid gap替代
    
    span {
      color: #888888;
      margin-left: 8px;
      word-break: break-word; // 长文本自动换行
    }
    
    // 全宽项目（如备注）
    &:last-child {
      grid-column: 1 / -1; // 跨两列
    }
  }
}

// 响应式调整 - 小屏幕适配
@media (max-width: 1200px) {
  #contract {
    min-width: 700px;
    gap: 15px;
    padding: 0 15px;
    
    .left {
      min-width: 280px;
      max-width: 350px;
    }
    
    .right {
      min-width: 350px;
    }
  }
  
  .card-info {
    grid-template-columns: 1fr; // 小屏幕改为单列
    gap: 10px;
  }
}

@media (max-width: 900px) {
  #contract {
    flex-direction: column; // 超小屏幕改为垂直布局
    min-width: 600px;
    
    .left, .right {
      min-width: 100%;
      max-width: 100%;
    }
    
    .right {
      min-width: 100%;
      
      .top {
        display: block; // 显示top区域
        height: 40px;
      }
    }
  }
}

// 表格容器响应式处理
.card-table-container {
  width: 100%;
  overflow-x: auto; // 表格水平滚动
  min-height: 200px;
  
  // 确保表格适应容器
  /deep/ .el-table {
    width: 100% !important;
    
    .el-table__body {
      min-width: 100%;
    }
  }
}

// 弹窗样式保持原有
.materialDetailTitle {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  
  .materialDetailTitle_title {
    font-size: clamp(18px, 2vw, 20px);
    font-weight: 500;
  }
  
  .materialDetailTitle_tool {
    display: flex;
    justify-content: space-evenly;
    width: 40%;
    align-items: center;
    
    @media (max-width: 768px) {
      width: 60%; // 小屏幕工具区域更宽
    }
  }
}

.taskDialog {
  height: 60vh; // 使用视口高度替代固定高度
  min-height: 400px;
  max-height: 800px;
}
</style>